import { Layout } from 'antd';
import { ReactNode } from 'react';

import AppHeader from '../AppHeader';

type Props = {
	children: ReactNode;
};

export default function MainLayout(props: Props) {
	const { children } = props;

	return (
		<Layout>
			<AppHeader />
			<Layout>{children}</Layout>
		</Layout>
	);
}
